<button
  class="opacity-80"
  mat-icon-button
  matTooltip="Device Settings"
  [matMenuTriggerFor]="moreMenu"
  [disabled]="disabled$ | async"
>
  <mat-icon>settings</mat-icon>
</button>

<mat-menu #moreMenu="matMenu" class="view-settings !min-w-[360px]">
  <form
    *ngrxLet="bridgeVersion$ as version"
    [formGroup]="twainDeviceSettingsForm"
  >
    <h3 class="settings-heading">TWAIN Device Settings</h3>

    @if ((isNaps2Active$ | async) === false) {
      <pt-settings-menu-slide-toggle-item
        label="Acquire Multiple Images"
        formControlName="multiImageEnabled"
        tooltip="Allows multiple images to be acquired and uploaded at once"
      />

      <pt-settings-menu-toggle-group-item
        label="Colour Mode"
        formControlName="colourMode"
        tooltip="Leave as Default to inherit from device driver. Set to Colour if you're having issues with colour images uploading as B&W."
        [options]="colourOptions"
      />

      <pt-settings-menu-toggle-group-item
        label="Transfer Mode"
        formControlName="transferMode"
        tooltip="Switch to Buffered mode only if you experience issues with distorted or misaligned scans. Otherwise, use the default Native for optimal scan speed."
        [options]="transferOptions"
      />

      <mat-divider />
    }

    <div class="flex items-center justify-between px-4">
      <span>Delete Device</span>
      <button mat-icon-button (click)="updateDevice({ deleted: true })">
        <mat-icon color="warn" class="opacity-80">delete</mat-icon>
      </button>
    </div>

    <div *prIsManagement class="management-only-menu-item">
      <mat-divider />

      <pt-settings-menu-toggle-group-item
        label="Driver"
        formControlName="implementation"
        tooltip="Select which scanning driver to use. Troubleshoot in this order: TwainCli > TwainSave > NAPS2."
        [options]="implementationOptions"
      />

      @if (isTwainCliActive$ | async) {
        <pt-settings-menu-slide-toggle-item
          label="Verbose Logging"
          formControlName="verboseLogging"
          tooltip="Enable detailed logging output from TwainCli for troubleshooting."
        />
      }
    </div>
  </form>
</mat-menu>
